<template>
  <div>
    <v-toolbar flat color="info" dark>
      <v-toolbar-title>Dashboard</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items class="ml-auto pr-2">
       <v-btn small flat class="filter-btn" @click="filterDialog = true">
  <v-icon left small>filter_list</v-icon>
  Filtrele
</v-btn>

        <!-- seçili filtre özeti -->
        <v-chip v-if="filterSummary" small class="ml-2" color="white" text-color="info">
          {{ filterSummary }}
        </v-chip>
      </v-toolbar-items>
    </v-toolbar>

    <!-- Filtre popup -->
    <v-dialog v-model="filterDialog" max-width="520">
      <v-card>
        <v-card-title class="headline">Filtre</v-card-title>
        <v-card-text>
          <v-radio-group v-model="filterType" row>
            <v-radio label="Son 7 Gün" value="7"></v-radio>
            <v-radio label="15 Gün" value="15"></v-radio>
            <v-radio label="30 Gün" value="30"></v-radio>
            <v-radio label="Özel Tarih" value="custom"></v-radio>
          </v-radio-group>

          <v-layout row wrap>
            <v-flex xs6>
              <v-menu v-model="fromMenu" :close-on-content-click="false" transition="scale-transition" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFrom"
                    label="Başlangıç"
                    prepend-icon="event"
                    readonly
                    dense
                    v-bind="attrs"
                    v-on="on"
                    :disabled="filterType !== 'custom'"
                  />
                </template>
                <v-date-picker v-model="dateFrom" locale="tr" @input="fromMenu = false"></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs6>
              <v-menu v-model="toMenu" :close-on-content-click="false" transition="scale-transition" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateTo"
                    label="Bitiş"
                    prepend-icon="event"
                    readonly
                    dense
                    v-bind="attrs"
                    v-on="on"
                    :disabled="filterType !== 'custom'"
                  />
                </template>
                <v-date-picker v-model="dateTo" locale="tr" @input="toMenu = false"></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>

          <small class="grey--text">Varsayılan: Son 7 gün</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="filterDialog = false">İptal</v-btn>
          <v-btn color="info" dark @click="applyFilter">Uygula</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container fluid>
      <v-layout row wrap>
        <!-- ADET -->
        <v-flex xs6 class="pa-2">
          <div class="card-wrap">
            <span class="card-label">ADET GRAFİĞİ</span>
            <v-card class="pa-3" height="360">
              <ve-histogram :data="adetChart" :settings="adetSettings" :extend="extendAdet" height="350px" />
            </v-card>
          </div>
        </v-flex>

        <!-- TUTAR -->
        <v-flex xs6 class="pa-2">
          <div class="card-wrap">
            <span class="card-label">TUTAR GRAFİĞİ</span>
            <v-card class="pa-3" height="360">
              <ve-histogram :data="tutarChart" :settings="tutarSettings" :extend="extendTutar" height="350px" />
            </v-card>
          </div>
        </v-flex>

        <!-- SATIŞ -->
        <v-flex xs6 class="pa-2">
          <div class="card-wrap">
            <span class="card-label">SATIŞ GRAFİĞİ</span>
            <v-card class="pa-3" height="360">
              <ve-histogram :data="satisChart" :settings="satisSettings" :extend="extendTRY" height="350px" />
            </v-card>
          </div>
        </v-flex>

        <!-- TAHSİLAT -->
        <v-flex xs6 class="pa-2">
          <div class="card-wrap">
            <span class="card-label">TAHSİLAT GRAFİĞİ</span>
            <v-card class="pa-3" height="360">
              <ve-histogram :data="tahsilatChart" :settings="tahsilatSettings" :extend="extendTRY" height="350px" />
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>


<script>
import VeHistogram from 'v-charts/lib/histogram.common'
//import 'v-charts/lib/style.css'
import auth from '../../../api/auth'

function fmt(d) {
  // YYYY-MM-DD
  const pad = n => String(n).padStart(2, '0')
  const dt = (d instanceof Date) ? d : new Date(d)
  return `${dt.getFullYear()}-${pad(dt.getMonth()+1)}-${pad(dt.getDate())}`
}
function addDays(d, n) { const x = new Date(d); x.setDate(x.getDate()+n); return x }
function diffDays(a, b) {
  const d1 = new Date(a); const d2 = new Date(b)
  return Math.round((d2 - d1) / 86400000) + 1 // dahil gün sayısı
}

export default {
  name: 'Dashboard',
  components: { VeHistogram },

  data () {
    const today = new Date()
    const weekAgo = addDays(today, -6)

    return {
      // ----- FILTRE DURUMU -----
      filterDialog: false,
      filterType: '7',             
      dateFrom: fmt(weekAgo),      
      dateTo: fmt(today),
      fromMenu: false,
      toMenu: false,

      

      baseUrl: process.env.VUE_APP_API_BASE || '',
      token: localStorage.getItem('jwt') || '',

      /* ---- ECharts presets ---- */
      extendTRY: {
        grid: { left: 60, right: 10, top: 30, bottom: 40, containLabel: true },
        tooltip: { trigger: 'axis' },
        xAxis: { axisLabel: { interval: 0, rotate: 20 } },
        series: { barWidth: 36 },
        yAxis: {
          axisLabel: {
            formatter (val) {
              try { return new Intl.NumberFormat('tr-TR').format(val) + ' ₺' }
              catch (e) { return val + ' ₺' }
            }
          }
        }
      },
      extendTutar: {
        color: ['#10B981', '#3B82F6'], // Tutar, Kâr
        grid: { left: 60, right: 10, top: 30, bottom: 40, containLabel: true },
        tooltip: { trigger: 'axis' },
        xAxis: { axisLabel: { interval: 0, rotate: 20 } },
        series: { barWidth: 36 },
        yAxis: {
          axisLabel: {
            formatter (val) {
              try { return new Intl.NumberFormat('tr-TR').format(val) + ' ₺' }
              catch (e) { return val + ' ₺' }
            }
          }
        }
      },
      extendAdet: {
        color: ['#06B6D4', '#F59E0B', '#8B5CF6'],
        grid: { left: 40, right: 10, top: 30, bottom: 40, containLabel: true },
        tooltip: { trigger: 'axis' },
        legend: { top: 0 },
        xAxis: { axisLabel: { interval: 0, rotate: 20 } },
        series: { barWidth: 36 }
      },

      /* ---- v-charts settings ---- */
      adetSettings: {
        yAxisName: ['Adet'],
        stack: { Toplam: ['İç Hat', 'Dış Hat', 'BSP'] }
      },
      tutarSettings: {
        yAxisName: ['Tutar (₺)'],
        dimension: ['kisi'],
        metrics: ['tutar', 'formul'],
        labelMap: { kisi: 'Kişi', tutar: 'Tutar', formul: 'Kâr' }
      },
      satisSettings: {
        yAxisName: ['Satış (₺)'],
        labelMap: { kisi: 'Kişi', pesin: 'Peşin', kredili: 'Kredili', kk: 'Kredi Kartı' },
        stack: { 'Satış': ['pesin', 'kredili', 'kk'] }
      },
      tahsilatSettings: {
        yAxisName: ['Tahsilat (₺)'],
        dimension: ['kisi'],
        metrics: ['tahsil', 'kalan'],
        labelMap: { kisi: 'Kişi', tahsil: 'Tahsilat', kalan: 'Kalan' },
        stack: { 'Net': ['tahsil', 'kalan'] }
      },

      /* ---- datasets ---- */
      adetChart:  { columns: ['Kişi', 'İç Hat', 'Dış Hat', 'BSP'], rows: [] },
      tutarChart: { columns: ['kisi', 'tutar', 'formul'], rows: [] },
      satisChart: { columns: ['kisi', 'pesin', 'kredili', 'kk'], rows: [] },
      tahsilatChart: { columns: ['kisi', 'tahsil', 'kalan', 'tam', 'parcali', 'odemeYok'], rows: [] },

      loading: false,
      err: null
    }
  },

  computed: {
    filterSummary () {
      if (this.filterType === '7')  return 'Son 7 Gün'
      if (this.filterType === '15') return 'Son 15 Gün'
      if (this.filterType === '30') return 'Son 30 Gün'
      return `${this.dateFrom} → ${this.dateTo}`
    }
  },

  mounted () { this.loadAll() },

  methods: {
    mapPeriodToApi (p) { return p === 15 ? '15D' : (p === 30 ? '30D' : '7D') },

    buildUrl (relativePath) {
      const base = (auth && auth.API_URL) ? auth.API_URL : this.baseUrl
      if (!base) throw new Error('API base URL tanımlı değil')
      const path = relativePath.charAt(0) === '/' ? relativePath.slice(1) : relativePath
      return base.endsWith('/') ? (base + path) : (base + '/' + path)
    },

    postJson (relativePath, body) {
      const url = this.buildUrl(relativePath)
      const bearer = (auth && typeof auth.getAuthHeader === 'function')
        ? ('Bearer ' + auth.getAuthHeader())
        : ('Bearer ' + (this.token || ''))
      return this.$http.post(url, body, {
        headers: { 'Authorization': bearer, 'Content-Type': 'application/json' },
        emulateJSON: false
      }).then(res => res.body)
    },

    val (obj, upperKey, lowerKey, dflt = '') {
      if (obj && obj[upperKey] != null) return obj[upperKey]
      if (obj && obj[lowerKey] != null) return obj[lowerKey]
      return dflt
    },
    num (obj, upperKey, lowerKey) {
      const v = (obj && obj[upperKey] != null) ? obj[upperKey]
              : (obj && obj[lowerKey] != null) ? obj[lowerKey] : 0
      return (v === '' || v == null) ? 0 : Number(v)
    },

    // Filtreyi uygula
    applyFilter () {
      // özel seçiliyse min/max düzeltmesi
      if (this.filterType === 'custom' && new Date(this.dateFrom) > new Date(this.dateTo)) {
        const tmp = this.dateFrom; this.dateFrom = this.dateTo; this.dateTo = tmp
      }
      this.filterDialog = false
      this.loadAll()
    },

    // API payload: şimdilik Period + (hazır olunca) BasTar/BitTar
    makePayload () {
      const payload = { SirketKodu: 1, KesenKisi: '' }

      if (this.filterType === 'custom') {
        payload.BasTar = this.dateFrom
        payload.BitTar = this.dateTo

        // gün farkı 7/15/30 ise Period’u da set et (geri uyumluluk)
        const d = diffDays(this.dateFrom, this.dateTo)
        if (d === 7)       payload.Period = '7D'
        else if (d === 15) payload.Period = '15D'
        else if (d === 30) payload.Period = '30D'
        else               payload.Period = '7D' // geçici fallback
      } else {
        payload.Period = this.mapPeriodToApi(Number(this.filterType))
      }
      return payload
    },

    async loadAll () {
      this.loading = true
      this.err = null
      try {
        const payload = this.makePayload()

        const [adetRes, tutarRes, odemeRes, tahsilatRes] = await Promise.all([
          this.postJson('api/Ticket/KesenKisiAdet',     payload),
          this.postJson('api/Ticket/KesenKisiTutar',    payload),
          this.postJson('api/Ticket/KesenKisiOdeme',    payload),
          this.postJson('api/Ticket/KesenKisiTahsilat', payload)
        ])

        const adet     = Array.isArray(adetRes)     ? adetRes     : []
        const tutar    = Array.isArray(tutarRes)    ? tutarRes    : []
        const odeme    = Array.isArray(odemeRes)    ? odemeRes    : []
        const tahsilat = Array.isArray(tahsilatRes) ? tahsilatRes : []

        // ADET
        this.adetChart = {
          columns: ['Kişi','İç Hat','Dış Hat','BSP'],
          rows: adet.map(x => ({
            'Kişi':   this.val(x, 'KesenKisi', 'kesenKisi', ''),
            'İç Hat': this.num(x, 'IcHat',  'icHat'),
            'Dış Hat':this.num(x, 'DisHat', 'disHat'),
            'BSP':    this.num(x, 'Bsp',    'bsp')
          }))
        }

        // TUTAR
        this.tutarChart = {
          columns: ['kisi','tutar','formul'],
          rows: tutar.map(x => ({
            kisi:   this.val(x, 'KesenKisi',   'kesenKisi', ''),
            tutar:  this.num(x, 'ToplamTutar', 'toplamTutar'),
            formul: this.num(x, 'FormulTutar', 'formulTutar')
          }))
        }

        // SATIŞ
        this.satisChart = {
          columns: ['kisi','pesin','kredili','kk'],
          rows: odeme.map(x => ({
            kisi:    this.val(x, 'KesenKisi',      'kesenKisi', ''),
            pesin:   this.num(x, 'PesinTutar',     'pesinTutar'),
            kredili: this.num(x, 'KrediliTutar',   'krediliTutar'),
            kk:      this.num(x, 'KrediKartTutar', 'krediKartTutar')
          }))
        }

        // TAHSİLAT
        this.tahsilatChart = {
          columns: ['kisi','tahsil','kalan','tam','parcali','odemeYok'],
          rows: tahsilat.map(x => ({
            kisi:      this.val(x, 'KesenKisi',       'kesenKisi', ''),
            tahsil:    this.num(x, 'TahsilToplam',    'tahsilToplam'),
            kalan:     this.num(x, 'KalanToplam',     'kalanToplam'),
            tam:       this.num(x, 'TamOdenenAdet',   'tamOdenenAdet'),
            parcali:   this.num(x, 'ParcaliOdenenAdet','parcaliOdenenAdet'),
            odemeYok:  this.num(x, 'OdenmeyenAdet',   'odenmeyenAdet')
          }))
        }
      } catch (e) {
        console.error('Grafik veri yükleme hatası:', e)
        this.err = (e && e.message) ? e.message : 'Veri alınamadı'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>







<style scoped>
.card-wrap { position: relative; }
.card-label {
  position: absolute;
  top: -10px;
  left: 12px;
  background: #fff;
  padding: 2px 8px;
  font-size: 12px;
  border-radius: 4px;
  z-index: 1;
  color: #555;
  border: 1px solid #eee;
}
.filter-btn {
  background: transparent !important;
  border-color: rgba(255,255,255,.75) !important;
  color: #fff !important;
  height: 32px;
  padding: 0 12px;
  min-width: 110px;
  text-transform: none;
}
.filter-btn .v-icon { color: inherit !important; }
.filter-btn:hover { background: rgba(255,255,255,.12) !important; }
</style>
